module.exports = __webpack_public_path__ + "img/icon_cancel.46e73791.svg";